import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tag-input',
  templateUrl: './tag-input.component.html',
  styleUrls: ['./tag-input.component.scss'],
})
export class TagInputComponent {
 @Input() emails: string[] = [];
  @Input() placeholder: string = 'Add email...';
  @Input() required: boolean = false;
  
  @Output() emailsChange = new EventEmitter<string[]>();
  @Output() onAdd = new EventEmitter<string>();
  @Output() onRemove = new EventEmitter<string>();
  
  inputValue: string = '';
  isFocused: boolean = false;
  showError: boolean = false;

  // Email validation
  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ',' || event.key === ';') {
      event.preventDefault();
      this.addEmail();
    } else if (event.key === 'Backspace' && this.inputValue === '' && this.emails.length > 0) {
      this.removeEmail(this.emails.length - 1);
    }
  }

  onBlur(): void {
    this.isFocused = false;
    if (this.inputValue.trim()) {
      this.addEmail();
    }
  }

  addEmail(): void {
    const email = this.inputValue.trim();
    
    if (!email) return;
    
    if (!this.isValidEmail(email)) {
      this.showError = true;
      setTimeout(() => this.showError = false, 3000);
      return;
    }
    
    if (this.emails.includes(email)) {
      return;
    }
    
    this.emails.push(email);
    this.inputValue = '';
    this.onAdd.emit(email);
    this.emailsChange.emit(this.emails);
  }

  removeEmail(index: number): void {
    const removedEmail = this.emails[index];
    this.emails.splice(index, 1);
    this.onRemove.emit(removedEmail);
    this.emailsChange.emit(this.emails);
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const emails = pastedData.split(/[,;\s\n]+/).map(e => e.trim()).filter(e => e);
    
    emails.forEach(email => {
      if (this.isValidEmail(email) && !this.emails.includes(email)) {
        this.emails.push(email);
        this.onAdd.emit(email);
      }
    });
    
    this.emailsChange.emit(this.emails);
  }
}
